import { MopResource } from './mopresource';

export class Region extends MopResource {
    public getSaveObject() {
        return {};
    }
}
